<template>
  <div class="settings w-[247px] overflow-hidden rounded-[6px] border border-[--v3-theme-primarydarkercolor] bg-[--v3-theme-primarydarkercolor] shadow-lg">
    <SettingShops />
    <div class="divide-y border-t border-[--v3-theme-primarydarkercolor]">
      <ConnectEtsyShop v-slot="{ showConnectShopDialog }" module="UserSettings">
        <SettingLink
          :name="connectShopText"
          :url="'#'"
          class="setting-link"
          @click.prevent="showConnectShopDialog"
        />
      </ConnectEtsyShop>
      <SettingLink
        :name="t('layout.logout')"
        class="setting-link"
        url="/logout"
        @click.prevent="logout"
      />
    </div>
  </div>
</template>

<script setup lang='ts'>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import ConnectEtsyShop from '@/common/components/organisms/ConnectEtsyShop';
import { useAuthStore } from '@/common/stores/auth';
import SettingLink from '@/modules/layout/components/atoms/SettingLink';
import SettingShops from '@/modules/layout/components/molecules/SettingShops';

const { t } = useI18n();
const { hasShopConnected, logout } = useAuthStore();

const connectShopText = computed(() => {
  return hasShopConnected ? t('layout.connect_another_shop') : t('layout.connect_shop');
});
</script>


